import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import ActionButtons from "../../components/action_buttons";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { axiosApi } from "../../../services/axios_api";
import { Checkbox } from "primereact/checkbox";

const RoleEditAddForm = ({
  onHide,
  editable,
  setRes,
  rowData,
  setShowDialog,
}) => {
  const [loading, setLoading] = useState(false);
  const [permissionsData, setPermissionsData] = useState([]);
 
  useEffect(() => {
 


    if (editable && rowData?.permissions) {
      setPermissionsData(rowData.permissions); 
    } else {
    const checkPermission = async () => {
      setLoading(true);
      try {
        const response = await axiosApi.get(`/Portal/lists/permissions`);
        const permissions = response.data.body.permissions || [];
        setPermissionsData(permissions);
      } catch (error) {
        toast.error("Failed to fetch permissions.");
      } finally {
        setLoading(false);
      }
    };
    checkPermission();
  }
  },  [editable, rowData]);

  const validationSchema = Yup.object({
    description: Yup.string().required("Description is required."),
    name: Yup.string().required("Name is required."),

  });

  const formik = useFormik({
    initialValues: {
      // id: rowData?.id || "",  
      name: rowData?.name || "",
      description: rowData?.description || "",
      permissions: permissionsData || [],
    },
    
     validationSchema,
     
     onSubmit: async (data) => {
      const updatedPermissions = permissionsData.map((module) => ({
        ...module,
        features: module.features.map((feature) => ({
          ...feature,
          // Keep all required fields intact
        })),
      }));
    
      const payload = {
        ...data,
        permissions: updatedPermissions,
      };
      setLoading(true);
      try {
          let response;
          if (editable) {
              payload.id = rowData.id;
              response = await axiosApi.put("/Portal/roles/edit", payload);
          } else {
              response = await axiosApi.post("/Portal/roles/add", payload);
          }
  
          console.log("API Response:", response.data);
  
          if (response.data.responseCode === "200") {
              toast.success(response.data?.responseDescription);
          } else {
              toast.error(
                  response.data?.responseDescription || "Something went wrong"
              );
          }
          setRes(response);
          setShowDialog(false);
      } catch (error) {
          toast.error(
              error.response?.data?.message ||
              "An error occurred. Please try again."
          );
      } finally {
          setLoading(false);
      }
  },
  
    });
    console.log('Final Payload:', {
      name: formik.values.name,
      description: formik.values.description,
      permissions: permissionsData,
  });

    const togglePermission = (moduleId, featureId, action) => {
      setPermissionsData((prevPermissionsData) =>
          prevPermissionsData.map((module) => {
              if (module.moduleId === moduleId) {
                  return {
                      ...module,
                      features: module.features.map((feature) => {
                          if (feature.featureId === featureId) {
                              return {
                                  ...feature,
                                  [action]: !feature[action], // Toggle the specific action
                              };
                          }
                          return feature;
                      }),
                  };
              }
              return module;
          })
      );
  };
    
  const renderFeaturePermissions = (moduleId, features) => {
    return features.map((feature) => (
      <tr key={feature.featureId}>
        <td>{feature.featureName}</td>
        {feature.permissionType === "IsEnabled" ? (
          // Render only the "IsEnabled" checkbox and no other actions
          <td>
            <Checkbox
              checked={feature.isEnabled}
              onChange={() =>
                togglePermission(moduleId, feature.featureId, "isEnabled")
              }
            />
          </td>
        ) : (
          // For other permission types, render the "canView", "canEdit", "canAdd", "canDelete" columns
          <>
            {["canView", "canEdit", "canAdd", "canDelete"].map((action) => (
              <td key={action}>
                <Checkbox
                  checked={feature[action]}
                  onChange={() =>
                    togglePermission(moduleId, feature.featureId, action)
                  }
                />
              </td>
            ))}
          </>
        )}
      </tr>
    ));
  };

  console.log('setPermissionsData', permissionsData)
  return (

    <div className="main-form">
      <form onSubmit={formik.handleSubmit}>
        <div className="p-fluid formgrid grid">
        <div className="field col-12 md:col-6">
            <label htmlFor="feeName">
              Role Name <span className="text-danger"> *</span>
            </label>
            <InputText
              id="name"
              type="name"
              name="name"
              value={formik.values.name}
              placeholder="Enter Role"
              onChange={formik.handleChange}
            />
            {formik.touched.name && formik.errors.name && (
              <small className="p-error">{formik.errors.name}</small>
            )}
          </div>

          <div className="field col-12 md:col-6">
            <label htmlFor="feeName">
              Description <span className="text-danger"> *</span>
            </label>
            <InputText
              keyfilter={/^[a-zA-Z\s]*$/}
              id="description"
              name="description"
              maxLength={"30"}
              value={formik.values.description}
              placeholder="Enter Name"
              onChange={formik.handleChange}
            />
            {formik.touched.description && formik.errors.description && (
              <small className="p-error">{formik.errors.description}</small>
            )}
          </div>

         
          <div className="field col-12 md:col-12">
            {permissionsData.map((module) => (
              <div key={module.moduleId}>
                {/* Dynamically render module name as heading */}
                <h4 className="mt-3">{module.moduleName}</h4>
                <table className="p-datatable w-100">
                  <thead>
                    <tr>
                      <th>Feature</th>
                      {module.features.some((feature) => feature.permissionType !== "IsEnabled") && (
                        <>
                          <th>View</th>
                          <th>Edit</th>
                          <th>Add</th>
                          <th>Delete</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {renderFeaturePermissions(module.moduleId, module.features)}
                  </tbody>
                </table>
              </div>
            ))}
          </div>

        </div>

        <div className="form-buttons mt-4">
          <ActionButtons
            loading={loading}
            onCancel={onHide}
            onSave={formik.handleSubmit}
            saveLabel={editable ? "Update Changes" : "Save Changes"}
            showSave={true}
            cancelLabel="Cancel"
          />
        </div>
      </form>
    </div>
  );
};

export default RoleEditAddForm;
